import * as React from 'react';
import {
  UnarchiveCategoryModalController,
  UnarchiveCategoryModalControllerProps
} from './UnarchiveCategoryModal.controller';
import { useUpdateCategoryMutation } from '../../../../models/graphql';

export type UnarchiveCategoryModalApolloProps = Omit<UnarchiveCategoryModalControllerProps, 'updateCategory'> & {
  // ...
};

export const UnarchiveCategoryModalApollo = (props: UnarchiveCategoryModalApolloProps): JSX.Element => {
  const [updateCategory] = useUpdateCategoryMutation();

  const controllerProps: UnarchiveCategoryModalControllerProps = {
    ...props,
    updateCategory
  };

  return <UnarchiveCategoryModalController {...controllerProps} />;
};
